<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link *ngIf="showBackButton"></mprd-back-link>
      <div class="row">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">{{ 'publicWifi.details.title' | translate }}</h1>

          <mprd-public-wifi-pxsplus-hotspot
            *ngIf="activeScreen === 'landpage'"
            [configureUrl]="configureUrl"
          ></mprd-public-wifi-pxsplus-hotspot>

          <mprd-public-wifi-pxsplus-configuration
            *ngIf="activeScreen === 'configuration'"
          ></mprd-public-wifi-pxsplus-configuration>

          <div class="rs-le2"></div>
        </div>
      </div>
    </section>
  </main>
</section>
